module.exports = __webpack_public_path__ + "img/EZ-Classroom-2.304ad2ae.png";